import "./Mobile.css";
import Nav from "../Nav";

export default function MobileNav({ isOpen }) {
  return (
    <div className={`mobile-nav ${isOpen ? "open" : ""}`}>
      <Nav className="mobile-nav-links" />
    </div>
  );
}
